var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletterWidget3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.83927V2.94641H27V8.83927H0Z",
    fill: "#A6CEE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.625V14.7321H11.4V20.625H0Z",
    fill: "#A6CEE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.4107V26.5179H19.2V32.4107H0Z",
    fill: "#A6CEE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.1964V38.3036H21V44.1964H0Z",
    fill: "#A6CEE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55.9822V50.0893H7.2V55.9822H0Z",
    fill: "#A6CEE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 8.83927V2.94641H51V8.83927H27Z",
    fill: "#1F78B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 20.625V14.7321H44.4V20.625H11.4Z",
    fill: "#1F78B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 32.4107V26.5179H57V32.4107H19.2Z",
    fill: "#1F78B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44.1964V38.3036H48.6V44.1964H21Z",
    fill: "#1F78B4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20001 55.9822V50.0893H41.4V55.9822H7.20001Z",
    fill: "#1F78B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterWidget3);
export default __webpack_public_path__ + "static/media/newsletterWidget3.03db0a625bb5edebff784803101b0fff.svg";
export { ForwardRef as ReactComponent };